module.exports = __webpack_public_path__ + "static/ana-ee31cba4925b7e79f4ee2fc16b03a761.png";